import { useCallback } from "react";
import { useWindowDimensions } from "react-native";

const breakpoints = {
  base: 0,
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
  "3xl": 1920,
};

type Breakpoint = keyof typeof breakpoints;

export function useBreakpoint() {
  const { width } = useWindowDimensions();

  const getBreakpoint: () => Breakpoint = () => {
    if (width >= breakpoints["3xl"]) return "3xl";
    if (width >= breakpoints["2xl"]) return "2xl";
    if (width >= breakpoints.xl) return "xl";
    if (width >= breakpoints.lg) return "lg";
    if (width >= breakpoints.md) return "md";
    if (width >= breakpoints.sm) return "sm";
    if (width >= breakpoints.base) return "base";
    return "base";
  };

  const isAbove = useCallback(
    (bp: Breakpoint) => width >= breakpoints[bp],
    [width],
  );

  const isBelow = useCallback(
    (bp: Breakpoint) => width < breakpoints[bp],
    [width],
  );

  return {
    width,
    current: getBreakpoint(),
    isAbove,
    isBelow,
  };
}
